module.exports = __webpack_public_path__ + "img/logo-tknl-fr.39250c5b.svg";